// src/components/result-page/search-tab/subcomponents/dashboard-tab-view/dashboard-widgets/dashboard-offsites-v3.tsx

// src/components/result-page/search-tab/subcomponents/dashboard-tab-view/dashboard-widgets/dashboard-offsites-v3.tsx
import {h, type FunctionalComponent} from '@stencil/core';
import type {IDashboardDesktopView} from '../dashboard-views/dashboard-desktop-view';

type DashboardOffsitesV3Props = Pick<IDashboardDesktopView, 'rtl' | 'analyticsTabName' | 'tabName' | 'query' | 'offsiteBannersManagerRequestData' | 'labelProvider' | 'brand' | 'country' | 'language' >;

export const DashboardOffsitesV3: FunctionalComponent<DashboardOffsitesV3Props> = (props) => {
    const {
      rtl,
      analyticsTabName,
      tabName,
      query,
      offsiteBannersManagerRequestData,
      labelProvider,
      brand,
      country,
      language
    } = props;

    return (
      <div
        class={{
          'offsites-container': true,
          'widget-offset--rtl': rtl
        }}
      >
        <uiaas-offsites-widget-v3
          isDashboard={true}
          computedPlacement={false}
          isRtl={rtl}
          analyticsTabName={analyticsTabName}
          tabName={tabName}
          term={query}
          offsiteBannersManagerRequestData={offsiteBannersManagerRequestData}
          labelProvider={(e, f) => labelProvider(e, f)}
          brand={brand}
          country={country}
          language={language}
        />
      </div>
    );
};
